import {
	ClockingUserDTO,
	GetClockingUserByCardNumberRequest,
	GetClockingUserByCardNumberResponse,
	GetClockingUsersRequest,
	GetClockingUsersResponse,
	GetWorkingPeriodStatusRequest,
	GetWorkingPeriodStatusResponse,
	RegisterClockInRequest,
	RegisterClockOutRequest,
	RegisterClockOutResponse,
	RegisterClockInResponse,
	WorkingPeriodStatusDTO
} from 'core/api';
import { Bus } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');

export async function getUserByCardNumber(cardNumber: string): Promise<ClockingUserDTO> {
	const request = new GetClockingUserByCardNumberRequest({ cardNumber });
	return process(request, (response: GetClockingUserByCardNumberResponse) => response.User);
}

export async function getWorkingPeriodStatus(userId: number): Promise<WorkingPeriodStatusDTO> {
	const request = new GetWorkingPeriodStatusRequest({ userId });
	return process(request, (response: GetWorkingPeriodStatusResponse) => response.WorkingPeriodStatus);
}

export async function getUsers(): Promise<ClockingUserDTO[]> {
	const request = new GetClockingUsersRequest();
	return process(request, (response: GetClockingUsersResponse) => response.Users);
}

export async function clockIn(workingPeriodStatus: WorkingPeriodStatusDTO): Promise<WorkingPeriodStatusDTO> {
	const request = new RegisterClockInRequest({ workingPeriodStatus });
	return process(request, (response: RegisterClockInResponse) => response.WorkingPeriodStatus);
}

export async function clockOut(workingPeriodStatus: WorkingPeriodStatusDTO): Promise<WorkingPeriodStatusDTO> {
	const request = new RegisterClockOutRequest({ workingPeriodStatus });
	return process(request, (response: RegisterClockOutResponse) => response.WorkingPeriodStatus);
}